/* ==========================================================================
   EVE Kissen-Finder – Logik und Oberfläche
   Ohne fremde Bibliotheken. Die Empfehlung (empfehle) ist eine reine Funktion
   und wird mit node --test geprüft (test/logik.test.mjs).
   Daten: <script type="application/json" data-kf-daten> aus sections/eve-kissen-finder.liquid
   ========================================================================== */
(function (global) {
  'use strict';

  /* Füllgewichte je Kissen, belegt durch die Produktbilder (Etikett „… g Füllung pro Kissen“), Stand 2026-10.
     Ändert Eve die Füllung, hier nachziehen. Schlüssel: kleineres × größeres Maß in cm. */
  var FUELLGEWICHT = {
    basic: { '40x40': 300, '40x80': 800, '50x50': 450, '50x70': 800, '60x60': 800, '80x80': 1000 },
    diamond: { '40x40': 350, '50x50': 500, '50x70': 750, '60x60': 700, '80x80': 1200 }
  };

  var MASS_STANDARD = { seite: '40x80', ruecken: '80x80', bauch: '40x80', wechsel: '80x80' };

  var FRAGEN = {
    einsatz: {
      frage: 'Wofür suchen Sie ein Kissen?',
      optionen: [
        { wert: 'bett', titel: 'Zum Schlafen im Bett', info: 'Kopfkissen', icon: 'bett' },
        { wert: 'koerper', titel: 'Für den ganzen Körper', info: 'Schwangerschaft, Seitenlage', icon: 'koerper' },
        { wert: 'sofa', titel: 'Für Sofa und Kissenbezüge', info: 'Füllkissen für Ihre Bezüge', icon: 'sofa' },
        { wert: 'reise', titel: 'Für unterwegs', info: 'Reise, Auto, Büro', icon: 'reise' }
      ]
    },
    lage: {
      frage: 'Wie schlafen Sie meistens?',
      optionen: [
        { wert: 'seite', titel: 'Auf der Seite' },
        { wert: 'ruecken', titel: 'Auf dem Rücken' },
        { wert: 'bauch', titel: 'Auf dem Bauch' },
        { wert: 'wechsel', titel: 'Mal so, mal so' }
      ]
    },
    hoehe: {
      frage: 'Wie soll Ihr Kissen sein?',
      hilfe: 'Die Füllmenge lässt sich später über den Reißverschluss anpassen.',
      optionen: [
        { wert: 'flach', titel: 'Eher flach und weich' },
        { wert: 'mittel', titel: 'Mittel' },
        { wert: 'hoch', titel: 'Eher hoch und fest' }
      ]
    },
    groesse: {
      frage: 'Welche Größe hat Ihr Kissenbezug?',
      hilfe: 'Kissen und Bezug sollten gleich groß sein. Das Maß steht meist auf dem Etikett des Bezugs.',
      optionen: [
        { wert: '80x80', titel: '80 × 80 cm', info: 'klassisch, viel Fläche' },
        { wert: '40x80', titel: '40 × 80 cm', info: 'schmal und lang' },
        { wert: '50x70', titel: '50 × 70 cm', info: 'schmal, etwas breiter' },
        { wert: '60x60', titel: '60 × 60 cm', info: 'quadratisch, mittel' },
        { wert: '50x50', titel: '50 × 50 cm', info: 'Sofa, Kinderbett' },
        { wert: '40x40', titel: '40 × 40 cm', info: 'Sofa, Deko' },
        { wert: 'unbekannt', titel: 'Weiß ich nicht', info: 'Bitte empfehlen Sie mir eine' }
      ]
    }
  };

  /** Reihenfolge der Fragen je Einsatz. */
  function pfad(antworten) {
    switch (antworten.einsatz) {
      case 'bett': return ['einsatz', 'lage', 'hoehe', 'groesse'];
      case 'sofa': return ['einsatz', 'hoehe', 'groesse'];
      case 'koerper':
      case 'reise': return ['einsatz'];
      default: return ['einsatz', 'lage', 'hoehe', 'groesse'];
    }
  }

  /* ---------- Hilfen für Produktdaten ---------- */

  /** „70x50 cm“, „40 x 80 cm“, „80×80“ → „50x70“, „40x80“, „80x80“ (kleineres Maß zuerst). */
  function massSchluessel(text) {
    var m = String(text || '').match(/(\d+)\s*[x×]\s*(\d+)/i);
    if (!m) return null;
    var a = parseInt(m[1], 10);
    var b = parseInt(m[2], 10);
    return Math.min(a, b) + 'x' + Math.max(a, b);
  }

  /** „Einzeln“ → 1, „4er Set“ → 4, sonst null. */
  function mengeZahl(text) {
    var t = String(text || '').trim();
    if (/^einzeln$/i.test(t)) return 1;
    var m = t.match(/^(\d+)\s*er[\s-]*set$/i);
    return m ? parseInt(m[1], 10) : null;
  }

  function massText(schluessel) {
    return schluessel ? schluessel.replace('x', ' × ') + ' cm' : '';
  }

  /** Welche Option ist Größe, Menge, Farbe? Erkannt an den Werten, nicht am Namen. */
  function optionsIndex(produkt) {
    var idx = { mass: -1, menge: -1, farbe: -1 };
    (produkt.optionen || []).forEach(function (name, i) {
      var werte = (produkt.varianten || []).map(function (v) { return v.optionen[i]; });
      if (werte.length && werte.every(function (w) { return massSchluessel(w); })) idx.mass = i;
      else if (werte.length && werte.every(function (w) { return mengeZahl(w) !== null; })) idx.menge = i;
      else if (/farbe|color/i.test(name)) idx.farbe = i;
    });
    return idx;
  }

  function variantenFuer(produkt, mass) {
    var idx = optionsIndex(produkt);
    return (produkt.varianten || []).filter(function (v) {
      return !mass || idx.mass < 0 || massSchluessel(v.optionen[idx.mass]) === mass;
    });
  }

  /** Einzelvariante in der Größe; bevorzugt verfügbar. */
  function einzelVariante(produkt, mass) {
    var idx = optionsIndex(produkt);
    var liste = variantenFuer(produkt, mass).filter(function (v) {
      return idx.menge < 0 || mengeZahl(v.optionen[idx.menge]) === 1;
    });
    return liste.filter(function (v) { return v.verfuegbar; })[0] || null;
  }

  function hatGroesse(produkt, mass) {
    return !!(produkt && einzelVariante(produkt, mass));
  }

  /** Set-Preise in der Größe: [{menge, preis, jeStueck, id}] nur verfügbare, ohne „Einzeln“. */
  function setPreise(produkt, mass) {
    var idx = optionsIndex(produkt);
    if (idx.menge < 0) return [];
    return variantenFuer(produkt, mass)
      .filter(function (v) { return v.verfuegbar && mengeZahl(v.optionen[idx.menge]) > 1; })
      .map(function (v) {
        var n = mengeZahl(v.optionen[idx.menge]);
        return { menge: n, preis: v.preis, jeStueck: Math.round(v.preis / n), id: v.id }; // kaufmännisch gerundet wie im Theme
      })
      .sort(function (a, b) { return a.menge - b.menge; });
  }

  function verfuegbareMasse(produkt) {
    var idx = optionsIndex(produkt);
    if (idx.mass < 0) return [];
    var s = {};
    produkt.varianten.forEach(function (v) {
      // nur Größen, die einzeln lieferbar sind – sonst fehlt der Empfehlung die Variante
      if (v.verfuegbar && (idx.menge < 0 || mengeZahl(v.optionen[idx.menge]) === 1)) s[massSchluessel(v.optionen[idx.mass])] = true;
    });
    return Object.keys(s);
  }

  function flaeche(schluessel) {
    var t = schluessel.split('x');
    return parseInt(t[0], 10) * parseInt(t[1], 10);
  }

  function produktMitRolle(daten, rolle) {
    return (daten.produkte || []).filter(function (p) { return p.rolle === rolle; });
  }

  function link(produkt, variante) {
    return produkt.url + (variante ? (produkt.url.indexOf('?') > -1 ? '&' : '?') + 'variant=' + variante.id : '');
  }

  function preisText(cent) {
    return new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(cent / 100);
  }

  /* ---------- Empfehlung ---------- */

  function empfehleKopfkissen(antworten, daten) {
    var basic = produktMitRolle(daten, 'basic')[0];
    var diamond = produktMitRolle(daten, 'diamond')[0];
    var fuellwatte = produktMitRolle(daten, 'fuellwatte')[0];
    var gruende = [];
    var hinweise = [];
    var annahme = false;

    var mass = antworten.groesse && antworten.groesse !== 'unbekannt' ? antworten.groesse : null;
    if (!mass) {
      annahme = true;
      mass = antworten.einsatz === 'sofa' ? '40x40' : MASS_STANDARD[antworten.lage] || '80x80';
    }

    // Kandidaten in dieser Größe (nur verfügbar)
    var kandidaten = [];
    if (basic && hatGroesse(basic, mass)) kandidaten.push({ rolle: 'basic', p: basic });
    if (diamond && hatGroesse(diamond, mass)) kandidaten.push({ rolle: 'diamond', p: diamond });

    if (!kandidaten.length) {
      // Größe gerade nicht lieferbar: nächstgelegene verfügbare Größe beim Basic, sonst beim Diamond
      var basis = basic && verfuegbareMasse(basic).length ? { rolle: 'basic', p: basic } :
        diamond && verfuegbareMasse(diamond).length ? { rolle: 'diamond', p: diamond } : null;
      if (!basis) return null;
      var wunsch = mass;
      mass = verfuegbareMasse(basis.p).sort(function (a, b) {
        return Math.abs(flaeche(a) - flaeche(wunsch)) - Math.abs(flaeche(b) - flaeche(wunsch));
      })[0];
      hinweise.push(massText(wunsch) + ' ist gerade nicht lieferbar. Wir zeigen Ihnen die nächstgelegene Größe.');
      kandidaten.push(basis);
    }

    // Modell wählen: „hoch“ → mehr Füllung in dieser Größe; sonst das Basic (günstiger, gleiche Füllwatte)
    var wahl = kandidaten[0];
    if (antworten.hoehe === 'hoch' && kandidaten.length > 1) {
      kandidaten.forEach(function (k) {
        var g = (FUELLGEWICHT[k.rolle] || {})[mass] || 0;
        var gw = (FUELLGEWICHT[wahl.rolle] || {})[mass] || 0;
        if (g > gw) wahl = k;
      });
    } else {
      kandidaten.forEach(function (k) { if (k.rolle === 'basic') wahl = k; });
    }

    var variante = einzelVariante(wahl.p, mass);
    var gewicht = (FUELLGEWICHT[wahl.rolle] || {})[mass];

    // Gründe
    if (annahme && antworten.einsatz === 'sofa') {
      gruende.push('40 × 40 cm ist ein gängiges Maß für Sofakissen. Messen Sie Ihren Bezug, bevor Sie bestellen.');
    } else if (annahme) {
      var massGrund = {
        seite: '40 × 80 cm ist schmal und lang: Das Kissen bleibt unter dem Kopf und rutscht nicht unter die Schulter.',
        ruecken: '80 × 80 cm bietet viel Fläche, Sie können das Kissen zurechtlegen oder falten.',
        bauch: '40 × 80 cm ist schmal; mit wenig Füllung liegt der Kopf flach.',
        wechsel: '80 × 80 cm lässt sich falten und für jede Lage formen.'
      };
      gruende.push(massGrund[antworten.lage] || 'Diese Größe passt zu den meisten Bezügen.');
    } else {
      gruende.push('Passend zu Ihrem Bezug in ' + massText(mass) + '.');
    }
    if (gewicht) {
      var andere = wahl.rolle === 'diamond' ? (FUELLGEWICHT.basic || {})[mass] : null;
      if (wahl.rolle === 'diamond' && andere && antworten.hoehe === 'hoch') {
        gruende.push('Mehr Füllung in dieser Größe: ' + gewicht.toLocaleString('de-DE') + ' g statt ' + andere.toLocaleString('de-DE') + ' g beim Basic.');
      } else {
        gruende.push(gewicht.toLocaleString('de-DE') + ' g Füllung aus unserer eigenen Füllwatte, per Reißverschluss anpassbar.');
      }
    } else {
      gruende.push('Füllmenge per Reißverschluss anpassbar.');
    }

    // Füll-Tipp
    var tipp;
    if (antworten.hoehe === 'flach') {
      tipp = 'Nehmen Sie über den Reißverschluss nach und nach Füllung heraus, bis Ihnen die Höhe gefällt. Heben Sie sie auf – so können Sie jederzeit nachfüllen.';
    } else if (antworten.hoehe === 'hoch') {
      tipp = 'Lassen Sie die Füllung zunächst ganz drin. Ist Ihnen das Kissen noch zu flach, füllen Sie mit unserer Füllwatte nach.';
    } else {
      tipp = 'Schlafen Sie ein, zwei Nächte mit voller Füllung. Danach wissen Sie, ob etwas heraus soll.';
    }
    if (antworten.lage === 'seite' && antworten.hoehe === 'flach') {
      hinweise.push('In Seitenlage liegt der Kopf höher als in Rückenlage. Nehmen Sie anfangs lieber wenig Füllung heraus.');
    }

    var zubehoer = null;
    if (antworten.hoehe === 'hoch' && fuellwatte) {
      var fw = (fuellwatte.varianten || []).filter(function (v) { return v.verfuegbar; });
      var klein = fw.filter(function (v) { return /250\s*(g|gramm)/i.test(v.titel); })[0] || fw[0];
      if (klein) zubehoer = { produkt: fuellwatte, variante: klein, text: 'Zum Nachfüllen, falls Sie es noch höher mögen.' };
    }

    var alternative = null;
    kandidaten.forEach(function (k) {
      if (k !== wahl) {
        alternative = {
          produkt: k.p,
          variante: einzelVariante(k.p, mass),
          text: k.rolle === 'diamond' ? 'Mit gesteppter Oberfläche im Rautenmuster.' : 'Glatte Oberfläche, gleiche Füllwatte.'
        };
      }
    });

    return {
      art: 'kopfkissen',
      haupt: { produkt: wahl.p, variante: variante, zusatz: massText(mass) + ', einzeln', sets: setPreise(wahl.p, mass), url: link(wahl.p, variante) },
      alternative: alternative,
      zubehoer: zubehoer,
      gruende: gruende,
      tipp: tipp,
      hinweise: hinweise
    };
  }

  function empfehleKoerper(daten) {
    var p = produktMitRolle(daten, 'koerper')[0];
    if (!p || !p.verfuegbar) return null;
    var idx = optionsIndex(p);
    var farben = p.varianten.filter(function (v) { return v.verfuegbar; }).map(function (v) {
      return { titel: idx.farbe > -1 ? v.optionen[idx.farbe] : v.titel, url: link(p, v), variante: v };
    });
    var v = farben[0].variante;
    return {
      art: 'koerper',
      haupt: { produkt: p, variante: v, zusatz: '130 × 70 cm', sets: [], url: link(p, v), farben: farben },
      alternative: null,
      zubehoer: null,
      gruende: [
        'Die U-Form stützt Kopf, Rücken, Bauch und Beine zugleich.',
        'Sie wechseln die Seite, ohne das Kissen umzulegen.',
        'Bezug abnehmbar, Kissen komplett waschbar bei 40 °C.'
      ],
      tipp: 'Auch zum Sitzen und Lesen im Bett: Legen Sie den Bogen in den Rücken und die Enden unter die Arme.',
      hinweise: []
    };
  }

  function empfehleReise(daten) {
    var liste = produktMitRolle(daten, 'nacken').filter(function (p) { return p.verfuegbar; });
    if (!liste.length) return null;
    var p = liste[0];
    var v = p.varianten.filter(function (x) { return x.verfuegbar; })[0];
    return {
      art: 'reise',
      haupt: { produkt: p, variante: v, zusatz: 'Memory-Schaum', sets: [], url: link(p, v) },
      motive: liste.map(function (q) {
        var qv = q.varianten.filter(function (x) { return x.verfuegbar; })[0];
        return { produkt: q, variante: qv, url: link(q, qv) };
      }),
      alternative: null,
      zubehoer: null,
      gruende: [
        'Nackenkissen mit Füllung aus Memory-Schaum für Reise, Auto und Büro.',
        'Bezug mit Reißverschluss, abnehmbar und waschbar.'
      ],
      tipp: 'Alle Motive haben dieselbe Form und Füllung – wählen Sie einfach das, das Ihnen gefällt.',
      hinweise: []
    };
  }

  /** Reine Funktion: Antworten + Produktdaten → Empfehlung oder null. */
  function empfehle(antworten, daten) {
    switch (antworten.einsatz) {
      case 'koerper': return empfehleKoerper(daten) || empfehleKopfkissen({ einsatz: 'bett', lage: 'seite', hoehe: 'mittel' }, daten);
      case 'reise': return empfehleReise(daten);
      case 'sofa':
      case 'bett': return empfehleKopfkissen(antworten, daten);
      default: return null;
    }
  }

  /* ======================================================================
     Oberfläche
     ====================================================================== */

  var ICONS = {
    bett: '<path d="M3 18v-6.5A1.5 1.5 0 0 1 4.5 10h15a1.5 1.5 0 0 1 1.5 1.5V18M3 15h18M3 18v2M21 18v2"/><rect x="5" y="6" width="6" height="4" rx="1.5" stroke-dasharray="2 1.6"/>',
    koerper: '<path d="M7 4v9a5 5 0 0 0 10 0V4"/><path d="M10.5 4v9a1.5 1.5 0 0 0 3 0V4" stroke-dasharray="2 1.6"/>',
    sofa: '<path d="M5 11V8a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v3"/><path d="M3 13a2 2 0 0 1 4 0v2h10v-2a2 2 0 0 1 4 0v4H3z"/><path d="M5 17v2M19 17v2"/>',
    reise: '<rect x="4" y="7" width="16" height="12" rx="2"/><path d="M9 7V5a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2M4 12h16" stroke-dasharray="2 1.6"/>'
  };

  function el(tag, attrs, kinder) {
    var e = document.createElement(tag);
    Object.keys(attrs || {}).forEach(function (k) {
      if (k === 'text') e.textContent = attrs[k];
      else if (k === 'html') e.innerHTML = attrs[k];
      else if (attrs[k] !== null && attrs[k] !== undefined && attrs[k] !== false) e.setAttribute(k, attrs[k] === true ? '' : attrs[k]);
    });
    (kinder || []).forEach(function (c) { if (c) e.appendChild(c); });
    return e;
  }

  function icon(name) {
    if (!ICONS[name]) return null;
    return el('span', {
      class: 'eve-kf__icon', 'aria-hidden': 'true',
      html: '<svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round">' + ICONS[name] + '</svg>'
    });
  }

  function massBild(schluessel) {
    if (!/^\d+x\d+$/.test(schluessel)) return null;
    var t = schluessel.split('x').map(Number);
    // Breite = größeres Maß, maßstäblich (80 cm ≙ 40 px)
    return el('span', { class: 'eve-kf__mass', 'aria-hidden': 'true', style: '--kf-w:' + (t[1] / 2) + 'px;width:' + (t[1] / 2) + 'px;height:' + (t[0] / 2) + 'px' });
  }

  function Finder(root) {
    this.root = root;
    this.id = root.getAttribute('data-section-id') || String(Math.random()).slice(2, 8);
    var datenEl = root.querySelector('[data-kf-daten]');
    try { this.daten = JSON.parse(datenEl ? datenEl.textContent : '{}'); } catch (e) { this.daten = { produkte: [] }; }
    this.form = root.querySelector('[data-kf-form]');
    this.buehne = root.querySelector('[data-kf-buehne]');
    this.stand = root.querySelector('[data-kf-stand]');
    this.fortschritt = root.querySelector('[data-kf-fortschritt]');
    this.zurueck = root.querySelector('[data-kf-zurueck]');
    this.fehler = root.querySelector('[data-kf-fehler]');
    this.ergebnis = root.querySelector('[data-kf-ergebnis]');
    this.antworten = {};
    this.schritt = 0;
    this.verdrahten();
    this.form.hidden = false;
    this.zeige(false);
  }

  Finder.prototype.verdrahten = function () {
    var self = this;
    this.form.addEventListener('submit', function (ev) { ev.preventDefault(); self.weiter(); });
    this.zurueck.addEventListener('click', function () { self.zurueckGehen(); });
    // Maus und Finger: Auswahl führt direkt weiter. Tastatur (Pfeiltasten, Leertaste) wählt nur aus –
    // diese Klicks haben detail 0. Der Timer fasst Label- und Input-Klick zu einem Schritt zusammen.
    var timer = null;
    this.buehne.addEventListener('click', function (ev) {
      var label = ev.target.closest('.eve-kf__option');
      if (!label || ev.detail === 0) return;
      clearTimeout(timer);
      timer = setTimeout(function () { self.weiter(); }, 180);
    });
    this.buehne.addEventListener('change', function () { self.fehler.hidden = true; });
  };

  Finder.prototype.frageSchluessel = function () { return pfad(this.antworten)[this.schritt]; };

  Finder.prototype.zeige = function (fokus) {
    var schluessel = this.frageSchluessel();
    var frage = FRAGEN[schluessel];
    var gesamt = pfad(this.antworten).length;
    var name = 'kf-' + this.id + '-' + schluessel;
    var self = this;

    var optionen = el('div', { class: 'eve-kf__optionen', 'data-art': schluessel });
    frage.optionen.forEach(function (o) {
      var input = el('input', { type: 'radio', name: name, value: o.wert, class: 'eve-kf__radio' });
      if (self.antworten[schluessel] === o.wert) input.checked = true;
      var inhalt = [input];
      if (o.icon) inhalt.push(icon(o.icon));
      if (schluessel === 'groesse') inhalt.push(massBild(o.wert) || el('span', { class: 'eve-kf__mass eve-kf__mass--frage', 'aria-hidden': 'true', text: '?' }));
      var text = el('span', { class: 'eve-kf__text' }, [el('span', { class: 'eve-kf__titel', text: o.titel }), o.info ? el('span', { class: 'eve-kf__info', text: o.info }) : null]);
      inhalt.push(text);
      optionen.appendChild(el('label', { class: 'eve-kf__option' }, inhalt));
    });

    var legende = el('legend', { class: 'eve-kf__frage', id: name + '-frage', tabindex: '-1', text: frage.frage });
    var feld = el('fieldset', { class: 'eve-kf__feld' }, [legende, frage.hilfe ? el('p', { class: 'eve-kf__hilfe', text: frage.hilfe }) : null, optionen]);

    this.buehne.innerHTML = '';
    this.buehne.appendChild(feld);
    this.stand.textContent = 'Frage ' + (this.schritt + 1) + ' von ' + gesamt;
    this.fortschritt.style.setProperty('--kf-anteil', ((this.schritt) / gesamt * 100) + '%');
    this.zurueck.hidden = this.schritt === 0;
    this.fehler.hidden = true;
    this.form.hidden = false;
    this.ergebnis.hidden = true;
    if (fokus) {
      legende.focus({ preventScroll: true });
      this.inSicht();
    }
  };

  /** Rutscht der Finder nach einem Schritt aus dem Bild (Handy), oben wieder ins Bild holen. */
  Finder.prototype.inSicht = function () {
    var oben = this.root.getBoundingClientRect().top;
    if (oben < 0) {
      var ruhig = global.matchMedia && global.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.root.scrollIntoView({ block: 'start', behavior: ruhig ? 'auto' : 'smooth' });
    }
  };

  Finder.prototype.weiter = function () {
    var schluessel = this.frageSchluessel();
    var gewaehlt = this.buehne.querySelector('input:checked');
    if (!gewaehlt) {
      this.fehler.hidden = false;
      var erstes = this.buehne.querySelector('input');
      if (erstes) erstes.focus();
      return;
    }
    if (schluessel === 'einsatz' && this.antworten.einsatz !== gewaehlt.value) {
      // anderer Einsatz: Antworten des alten Pfads verwerfen
      this.antworten = {};
    }
    this.antworten[schluessel] = gewaehlt.value;
    if (this.schritt + 1 < pfad(this.antworten).length) {
      this.schritt += 1;
      this.zeige(true);
    } else {
      this.zeigeErgebnis();
    }
  };

  Finder.prototype.zurueckGehen = function () {
    if (this.schritt > 0) { this.schritt -= 1; this.zeige(true); }
  };

  Finder.prototype.neu = function () {
    this.antworten = {};
    this.schritt = 0;
    this.zeige(true);
  };

  function produktKarte(e, klasse) {
    var p = e.produkt;
    var bild = p.bild ? el('img', { src: p.bild, alt: '', width: '240', height: '240', loading: 'lazy', class: 'eve-kf__bild' }) : null;
    var preis = e.variante ? preisText(e.variante.preis) : '';
    return el('a', { class: klasse, href: e.url || link(p, e.variante) }, [
      bild,
      el('span', { class: 'eve-kf__karte-text' }, [
        el('span', { class: 'eve-kf__karte-titel', text: p.titel }),
        e.text ? el('span', { class: 'eve-kf__karte-info', text: e.text }) : null,
        el('span', { class: 'eve-kf__karte-preis', text: preis })
      ])
    ]);
  }

  Finder.prototype.zeigeErgebnis = function () {
    var self = this;
    var r = empfehle(this.antworten, this.daten);
    var box = this.ergebnis;
    box.innerHTML = '';

    var titel = el('h3', { class: 'eve-kf__ergebnis-titel', tabindex: '-1', text: 'Unsere Empfehlung für Sie' });
    box.appendChild(titel);

    if (!r) {
      box.appendChild(el('p', { class: 'eve-kf__leer', text: 'Für diese Auswahl ist gerade nichts lieferbar. Schauen Sie sich unsere Kissen an oder schreiben Sie uns – wir beraten Sie gern.' }));
      box.appendChild(el('a', { class: 'eve-kf__button', href: this.root.getAttribute('data-fallback-url') || '/collections/kissen', text: 'Alle Kissen ansehen' }));
    } else {
      var h = r.haupt;
      var p = h.produkt;
      var kopf = el('div', { class: 'eve-kf__treffer' }, [
        p.bild ? el('img', { src: p.bild, alt: p.titel, width: '480', height: '480', class: 'eve-kf__treffer-bild' }) : null,
        el('div', { class: 'eve-kf__treffer-text' }, [
          el('p', { class: 'eve-kf__treffer-name', text: p.titel }),
          el('p', { class: 'eve-kf__treffer-zusatz', text: h.zusatz }),
          el('p', { class: 'eve-kf__treffer-preis', text: h.variante ? preisText(h.variante.preis) : '' }),
          h.sets && h.sets.length ? el('p', { class: 'eve-kf__sets', text: 'Auch im Set: ' + h.sets.map(function (s) { return s.menge + 'er ' + preisText(s.jeStueck) + ' je Stück'; }).join(', ') }) : null,
          h.farben && h.farben.length > 1 ? el('p', { class: 'eve-kf__farben' }, [document.createTextNode('Erhältlich in ')].concat(h.farben.map(function (f, i) {
            return el('span', {}, [el('a', { href: f.url, class: 'eve-kf__link', text: f.titel }), document.createTextNode(i < h.farben.length - 2 ? ', ' : i === h.farben.length - 2 ? ' und ' : '.')]);
          }))) : null,
          el('ul', { class: 'eve-kf__gruende' }, r.gruende.map(function (g) { return el('li', { text: g }); })),
          el('div', { class: 'eve-kf__aktionen' }, [
            h.variante ? el('button', { type: 'button', class: 'eve-kf__button', 'data-kf-kaufen': h.variante.id, text: 'In den Warenkorb' }) : null,
            el('a', { class: 'eve-kf__nochmal', href: h.url, text: 'Details ansehen' })
          ]),
          el('p', { class: 'eve-kf__kauf-fehler', 'data-kf-kauf-fehler': true, role: 'alert', hidden: true }),
          el('p', { class: 'eve-kf__textaktionen' }, [
            el('button', { type: 'button', class: 'eve-kf__textbutton', 'data-kf-aendern': true, text: 'Antworten ändern' }),
            el('button', { type: 'button', class: 'eve-kf__textbutton', 'data-kf-neu': true, text: 'Neu starten' })
          ])
        ])
      ]);
      box.appendChild(kopf);

      if (r.tipp || r.hinweise.length) {
        box.appendChild(el('div', { class: 'eve-kf__tipp' }, [
          el('p', { class: 'eve-kf__tipp-titel', text: 'Tipp zur Füllung' }),
          r.tipp ? el('p', { text: r.tipp }) : null
        ].concat(r.hinweise.map(function (t) { return el('p', { class: 'eve-kf__hinweis', text: t }); }))));
      }

      var weitere = [];
      if (r.motive && r.motive.length > 1) {
        r.motive.slice(1).forEach(function (m) { weitere.push(produktKarte({ produkt: m.produkt, variante: m.variante, url: m.url, text: 'Anderes Motiv' }, 'eve-kf__karte')); });
      }
      if (r.alternative && r.alternative.variante) weitere.push(produktKarte(r.alternative, 'eve-kf__karte'));
      if (r.zubehoer) weitere.push(produktKarte(r.zubehoer, 'eve-kf__karte'));
      if (weitere.length) {
        box.appendChild(el('p', { class: 'eve-kf__weitere-titel', text: 'Auch passend' }));
        box.appendChild(el('div', { class: 'eve-kf__weitere' }, weitere));
      }
    }

    var neu = box.querySelector('[data-kf-neu]');
    if (neu) neu.addEventListener('click', function () { self.neu(); });
    else {
      var b = el('button', { type: 'button', class: 'eve-kf__nochmal', text: 'Neu starten' });
      b.addEventListener('click', function () { self.neu(); });
      box.appendChild(b);
    }
    var aendern = box.querySelector('[data-kf-aendern]');
    if (aendern) aendern.addEventListener('click', function () {
      self.schritt = pfad(self.antworten).length - 1;
      self.zeige(true);
    });
    var kaufen = box.querySelector('[data-kf-kaufen]');
    if (kaufen) kaufen.addEventListener('click', function () {
      self.inDenWarenkorb(kaufen, [{ id: Number(kaufen.getAttribute('data-kf-kaufen')), quantity: 1 }], box.querySelector('[data-kf-kauf-fehler]'));
    });

    this.form.hidden = true;
    box.hidden = false;
    this.fortschritt.style.setProperty('--kf-anteil', '100%');
    titel.focus({ preventScroll: false });
  };

  /** Legt Artikel über die Ajax-API in den Warenkorb und öffnet danach den Warenkorb. */
  Finder.prototype.inDenWarenkorb = function (knopf, items, fehlerEl) {
    var root = this.root;
    var ziel = (root.getAttribute('data-cart-add-url') || '/cart/add') + '.js';
    var warenkorb = root.getAttribute('data-cart-url') || '/cart';
    var text = knopf.textContent;
    knopf.disabled = true;
    knopf.setAttribute('aria-busy', 'true');
    knopf.textContent = 'Wird hinzugefügt …';
    if (fehlerEl) fehlerEl.hidden = true;
    fetch(ziel, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (antwort) {
      if (!antwort.ok) throw new Error(String(antwort.status));
      global.location.href = warenkorb;
    }).catch(function () {
      knopf.disabled = false;
      knopf.removeAttribute('aria-busy');
      knopf.textContent = text;
      if (fehlerEl) {
        fehlerEl.textContent = 'Das hat nicht geklappt. Bitte versuchen Sie es über „Details ansehen“ noch einmal.';
        fehlerEl.hidden = false;
      }
    });
  };

  var api = {
    FRAGEN: FRAGEN,
    FUELLGEWICHT: FUELLGEWICHT,
    pfad: pfad,
    massSchluessel: massSchluessel,
    mengeZahl: mengeZahl,
    optionsIndex: optionsIndex,
    setPreise: setPreise,
    empfehle: empfehle,
    preisText: preisText
  };

  if (typeof module !== 'undefined' && module.exports) {
    module.exports = api;
  } else {
    global.EveKissenFinder = api;
    var start = function () {
      Array.prototype.forEach.call(document.querySelectorAll('[data-eve-kf]:not([data-kf-bereit])'), function (root) {
        root.setAttribute('data-kf-bereit', '');
        new Finder(root);
      });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
    else start();
    // Theme-Editor: Sektion neu geladen
    document.addEventListener('shopify:section:load', start);
  }
})(typeof window !== 'undefined' ? window : globalThis);
